import type * as ents from '@attain-apps/entities'
import * as graphql from '@attain-apps/fe/web/main/lib/graphql'

import * as enums from '../../enums'
import * as dimensionFilter from '../dimension-filter'

export const FILTER_INPUT = graphql.transformers.IN.object<
  ents.extra.space.Report.Configuration.SpaceSalaryComparison.Filter,
  graphql.schema.SpaceSalaryComparisonFilterInput
>({
  organizationFilter: dimensionFilter.TRANSFORMER,
})

export const CONFIGURATION_INPUT = graphql.transformers.IN.object<
  ents.extra.space.Report.Configuration.SpaceSalaryComparison,
  graphql.schema.SpaceReportSpaceSalaryComparisonConfigurationInput
>({
  filter: graphql.transformers.IN.nonNull(FILTER_INPUT),
  format: graphql.transformers.IN.nonNull(enums.format.TRANSFORMER),
})
